module.exports = __webpack_public_path__ + "img/slide5.8632e8dc.jpg";